import { BenefitDefinition } from "../../../benefits/benefit.types";
import * as sharedCellSpecs from "../cellSpecs/common";

/**
 * A benefit row the marketing presentation carries but no API field backs yet
 * (CD-386).
 *
 * The Chameleon workbook lets a broker show or hide far more rows than the
 * side-by-side models — Dental PPO alone has 19 such rows, LTD 38. These exist
 * so the side-by-side can mirror what the presentation will render, and so a
 * broker's configuration has something to act on.
 *
 * Two guards come with that: `mpOnly` keeps the row out of the Build tab, where
 * a field with no backing data has no place, and `isReadOnly` keeps an analyst
 * from typing into a cell nothing would persist. Both come off once the field is
 * wired to the API.
 *
 * @param label - the row's label in the workbook, used verbatim so the two read alike
 * @param mpConfigKey - the configuration field that shows or hides this row
 */
export const mpOnlyRow = (
  label: string,
  mpConfigKey: string,
): BenefitDefinition => ({
  label,
  mpConfigKey,
  mpOnly: true,
  isReadOnly: true,
  cell: sharedCellSpecs.text,
});
